import { omit } from 'underscore';
import { ICaptions } from 'types';
import measurement, { Pixels } from 'utils/measurement';
import { CaptionsState } from '../../types';
import { FALLBACK_VIEWPORT } from './constants';

export const getCaptionsFromConfig = (
  captions: ICaptions,
): CaptionsState | undefined => {
  const viewport = captions.editor?.styleContext?.viewport ?? FALLBACK_VIEWPORT;
  const textBoxHeight = captions.editor?.styleContext?.textBoxHeight ?? 0;

  const height = new Pixels(textBoxHeight).toUnit('vh', viewport);
  const width = captions.containerStyle?.width;
  const left = captions.region?.properties?.left ?? 0;
  const top = captions.region?.properties?.top ?? 0;

  return {
    advancedTextConfigs: captions.advancedTextConfigs,
    advancedAnimation: captions.advancedAnimation,
    captionSource: captions.captionSource,
    animation: captions.animation,
    containerStyle: omit(captions.containerStyle, ['width']),
    editor: captions.editor,
    position: {
      left: measurement(left),
      top: measurement(top),
    },
    size: {
      height: measurement(height.toString()),
      width: measurement(width),
    },
    region: captions.region,
    textStyle: captions.textStyle,
    textBoxHeight,
  };
};
